import axiosInstance from "./axiosinstance";


export interface Types {
  id: string;
  type: string;
  values: string[];
}

export interface TypesResponse {
  data: Types[];
}


export const settingRepository = {

  getSetting: async (pageIndex:number, pageSize:number, search:string): Promise<Types[]> => {
    try {
      const response = await axiosInstance.get<TypesResponse>(
        "/api/masterdata",{ params:{ pageIndex, pageSize, search }}
      );

      return response.data.data;
    } catch (error) {
      console.error("Error fetching master data:", error);
      throw error;
    }
  },


  postSetting: async (setting: Types): Promise<Types> => {
    const { data } = await axiosInstance.post<Types>("/api/masterdata", setting);
    return data;
  },

  putSetting: async (
    id: string,
    setting: Types
  ): Promise<Types> => {
    const { data } = await axiosInstance.put<Types>(
      `/api/masterdata/${id}`,
      setting
    );

    return data;
  },

  deleteValue: async (id: string, value: string): Promise<void> => {
    await axiosInstance.delete(`/api/masterdata/${id}/value`, {
      params: { value },
    });
  },
  
}

export const getMasterDataValues = async (
  aliases: string[],
  providedMasterData?: Types[]
): Promise<string[]> => {
  const normalize = (value: string) =>
    value.trim().toLowerCase().replace(/[^a-z0-9]/g, "");
  const normalizedAliases = aliases.map(normalize);
  const masterData =
    providedMasterData ?? (await settingRepository.getSetting(1, 1000, ""));
  const category = masterData.find((item) => {
    const itemType = normalize(item.type);
    return normalizedAliases.some(
      (alias) =>
        itemType === alias ||
        itemType.startsWith(alias) ||
        alias.startsWith(itemType)
    );
  });

  if (!category) {
    throw new Error(
      `Master Data category "${aliases[0]}" was not found. Check its name in the Types page.`
    );
  }

  return category.values;
};